<template>
  <el-dialog
    title="定向区域"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose">
    <div id="app">

      <!-- 操作按钮 -->
      <div class="operation-btns">
        <button class="btn btn-unlimited" :class="{ active: !isSet }" @click="isSet = false">不限</button>
        <button class="btn btn-set" :class="{ active: isSet }" @click="isSet = true">设置</button>
      </div>
      <!-- 搜索框 -->
      <div class="search-box" v-if="isSet">
        <div class="search-container">
          <input
            v-model="searchKey"
            type="text"
            placeholder="省市搜索不支持按拼音、拼音首字母"
            class="search-input"
            @input="handleSearch"
          />
          <i class="icon-search"></i>
        </div>
        <!-- 搜索结果下拉框 -->
        <div v-if="searchResults.length > 0 && searchKey" class="search-results">
          <div
            v-for="item in searchResults"
            :key="item.tagId"
            class="search-result-item"
            @click="selectSearchResult(item)"
          >
            {{ item.tagName }}
          </div>
        </div>
      </div>
      <!-- 省份城市选择区域和已选城市区域 -->
      <div class="area-container" v-if="isSet">
        <!-- 省份城市选择区域 -->
        <div class="select-area">
          <div class="province-list">
            <div class="stay-type-switch">
              <button
                class="btn btn-stay"
                :class="{ active: stayType === 1 }"
                @click="stayType = 1"
              >
                常驻
              </button>
              <button
                class="btn btn-current"
                :class="{ active: stayType === 2 }"
                @click="stayType = 2"
              >
                当前
              </button>
            </div>
            <div class="province-item">
              <div class="province-header">
                <input
                  type="checkbox"
                  id="checkbox-all"
                  @change="selectAllProvinces"
                  :checked="isAllSelected"
                >
                <span class="province-name">全选</span>
              </div>
            </div>
            <div
              v-for="province in provincesWithCities"
              :key="province.tagId"
              class="province-item"
            >
              <div class="province-header">
                <input
                  type="checkbox"
                  :id="'checkbox-' + province.tagId"
                  @change="toggleProvince(province)"
                  :checked="isProvinceSelected(province)"
                  :ref="'provinceCheckbox-' + province.tagId"
                >
                <span
                  class="province-name"
                  @click="showCities(province)"
                >
                {{ province.tagName }}
              </span>
                <span v-if="province.childBaseTag" class="expand-icon" @click="showCities(province)">›</span>
              </div>
              <!-- 城市列表 -->
              <div v-if="expandedProvinces.includes(province.tagId) && province.childBaseTag" class="city-list">
                <div
                  v-for="city in province.childBaseTag"
                  :key="city.tagId"
                  class="city-item"
                >
                  <input
                    type="checkbox"
                    :id="'city-' + city.tagId"
                    :checked="selectedCities.includes(city.tagId)"
                    @change="toggleCity(city)"
                  >
                  <label :for="'city-' + city.tagId">{{ city.tagName }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 已选城市区域 -->
        <div class="selected-area">
          <div class="selected-cities-header">
            已选城市 {{ totalSelectedCount }} / 370
            <button class="clear-btn" @click="clearSelected">清空</button>
          </div>
          <div class="selected-cities-list">
            <div v-for="item in formattedSelectedItems" :key="item.id" class="selected-item">
              {{ item.label }}
              <span class="close-btn" @click="removeItem(item)">×</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelSelection">取 消</el-button>
      <el-button type="primary" @click="confirmSelection">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "Region",
  data() {
    return {
      dialogVisible: false,
      isSet: false, // 控制“不限”和“设置”状态
      searchKey: '', // 搜索关键字
      selectedProvinces: [], // 已选省份
      selectedCities: [], // 已选城市
      expandedProvinces: [], // 展开的省份列表
      lastExpandedProvince: null, // 上一个展开的省份
      provincesWithCities: [
        {
          "tagId": 110000,
          "tagName": "北京",
          "childBaseTag": null
        },
        {
          "tagId": 120000,
          "tagName": "天津",
          "childBaseTag": null
        },
        {
          "tagId": 130000,
          "tagName": "河北省",
          "childBaseTag": [
            {
              "tagId": 130100,
              "tagName": "石家庄市"
            },
            {
              "tagId": 130200,
              "tagName": "唐山市"
            },
            {
              "tagId": 130300,
              "tagName": "秦皇岛市"
            },
            {
              "tagId": 130400,
              "tagName": "邯郸市"
            },
            {
              "tagId": 130500,
              "tagName": "邢台市"
            },
            {
              "tagId": 130600,
              "tagName": "保定市"
            },
            {
              "tagId": 130700,
              "tagName": "张家口市"
            },
            {
              "tagId": 130800,
              "tagName": "承德市"
            },
            {
              "tagId": 130900,
              "tagName": "沧州市"
            },
            {
              "tagId": 131000,
              "tagName": "廊坊市"
            },
            {
              "tagId": 131100,
              "tagName": "衡水市"
            }
          ]
        },
        {
          "tagId": 140000,
          "tagName": "山西省",
          "childBaseTag": [
            {
              "tagId": 140100,
              "tagName": "太原市"
            },
            {
              "tagId": 140200,
              "tagName": "大同市"
            },
            {
              "tagId": 140300,
              "tagName": "阳泉市"
            },
            {
              "tagId": 140400,
              "tagName": "长治市"
            },
            {
              "tagId": 140500,
              "tagName": "晋城市"
            },
            {
              "tagId": 140600,
              "tagName": "朔州市"
            },
            {
              "tagId": 140700,
              "tagName": "晋中市"
            },
            {
              "tagId": 140800,
              "tagName": "运城市"
            },
            {
              "tagId": 140900,
              "tagName": "忻州市"
            },
            {
              "tagId": 141000,
              "tagName": "临汾市"
            },
            {
              "tagId": 141100,
              "tagName": "吕梁市"
            }
          ]
        },
        {
          "tagId": 150000,
          "tagName": "内蒙古自治区",
          "childBaseTag": [
            {
              "tagId": 150100,
              "tagName": "呼和浩特市"
            },
            {
              "tagId": 150200,
              "tagName": "包头市"
            },
            {
              "tagId": 150300,
              "tagName": "乌海市"
            },
            {
              "tagId": 150400,
              "tagName": "赤峰市"
            },
            {
              "tagId": 150500,
              "tagName": "通辽市"
            },
            {
              "tagId": 150600,
              "tagName": "鄂尔多斯市"
            },
            {
              "tagId": 150700,
              "tagName": "呼伦贝尔市"
            },
            {
              "tagId": 150800,
              "tagName": "巴彦淖尔市"
            },
            {
              "tagId": 150900,
              "tagName": "乌兰察布市"
            },
            {
              "tagId": 152200,
              "tagName": "兴安盟"
            },
            {
              "tagId": 152500,
              "tagName": "锡林郭勒盟"
            },
            {
              "tagId": 152900,
              "tagName": "阿拉善盟"
            }
          ]
        },
        {
          "tagId": 210000,
          "tagName": "辽宁省",
          "childBaseTag": [
            {
              "tagId": 210100,
              "tagName": "沈阳市"
            },
            {
              "tagId": 210200,
              "tagName": "大连市"
            },
            {
              "tagId": 210300,
              "tagName": "鞍山市"
            },
            {
              "tagId": 210400,
              "tagName": "抚顺市"
            },
            {
              "tagId": 210500,
              "tagName": "本溪市"
            },
            {
              "tagId": 210600,
              "tagName": "丹东市"
            },
            {
              "tagId": 210700,
              "tagName": "锦州市"
            },
            {
              "tagId": 210800,
              "tagName": "营口市"
            },
            {
              "tagId": 210900,
              "tagName": "阜新市"
            },
            {
              "tagId": 211000,
              "tagName": "辽阳市"
            },
            {
              "tagId": 211100,
              "tagName": "盘锦市"
            },
            {
              "tagId": 211200,
              "tagName": "铁岭市"
            },
            {
              "tagId": 211300,
              "tagName": "朝阳市"
            },
            {
              "tagId": 211400,
              "tagName": "葫芦岛市"
            }
          ]
        },
        {
          "tagId": 220000,
          "tagName": "吉林省",
          "childBaseTag": [
            {
              "tagId": 220100,
              "tagName": "长春市"
            },
            {
              "tagId": 220200,
              "tagName": "吉林市"
            },
            {
              "tagId": 220300,
              "tagName": "四平市"
            },
            {
              "tagId": 220400,
              "tagName": "辽源市"
            },
            {
              "tagId": 220500,
              "tagName": "通化市"
            },
            {
              "tagId": 220600,
              "tagName": "白山市"
            },
            {
              "tagId": 220700,
              "tagName": "松原市"
            },
            {
              "tagId": 220800,
              "tagName": "白城市"
            },
            {
              "tagId": 222400,
              "tagName": "延边朝鲜族自治州"
            }
          ]
        },
        {
          "tagId": 230000,
          "tagName": "黑龙江省",
          "childBaseTag": [
            {
              "tagId": 230100,
              "tagName": "哈尔滨市"
            },
            {
              "tagId": 230200,
              "tagName": "齐齐哈尔市"
            },
            {
              "tagId": 230300,
              "tagName": "鸡西市"
            },
            {
              "tagId": 230400,
              "tagName": "鹤岗市"
            },
            {
              "tagId": 230500,
              "tagName": "双鸭山市"
            },
            {
              "tagId": 230600,
              "tagName": "大庆市"
            },
            {
              "tagId": 230700,
              "tagName": "伊春市"
            },
            {
              "tagId": 230800,
              "tagName": "佳木斯市"
            },
            {
              "tagId": 230900,
              "tagName": "七台河市"
            },
            {
              "tagId": 231000,
              "tagName": "牡丹江市"
            },
            {
              "tagId": 231100,
              "tagName": "黑河市"
            },
            {
              "tagId": 231200,
              "tagName": "绥化市"
            },
            {
              "tagId": 232700,
              "tagName": "大兴安岭地区"
            }
          ]
        },
        {
          "tagId": 310000,
          "tagName": "上海",
          "childBaseTag": null
        },
        {
          "tagId": 320000,
          "tagName": "江苏省",
          "childBaseTag": [
            {
              "tagId": 320100,
              "tagName": "南京市"
            },
            {
              "tagId": 320200,
              "tagName": "无锡市"
            },
            {
              "tagId": 320300,
              "tagName": "徐州市"
            },
            {
              "tagId": 320400,
              "tagName": "常州市"
            },
            {
              "tagId": 320500,
              "tagName": "苏州市"
            },
            {
              "tagId": 320600,
              "tagName": "南通市"
            },
            {
              "tagId": 320700,
              "tagName": "连云港市"
            },
            {
              "tagId": 320800,
              "tagName": "淮安市"
            },
            {
              "tagId": 320900,
              "tagName": "盐城市"
            },
            {
              "tagId": 321000,
              "tagName": "扬州市"
            },
            {
              "tagId": 321100,
              "tagName": "镇江市"
            },
            {
              "tagId": 321200,
              "tagName": "泰州市"
            },
            {
              "tagId": 321300,
              "tagName": "宿迁市"
            }
          ]
        },
        {
          "tagId": 330000,
          "tagName": "浙江省",
          "childBaseTag": [
            {
              "tagId": 330100,
              "tagName": "杭州市"
            },
            {
              "tagId": 330200,
              "tagName": "宁波市"
            },
            {
              "tagId": 330300,
              "tagName": "温州市"
            },
            {
              "tagId": 330400,
              "tagName": "嘉兴市"
            },
            {
              "tagId": 330500,
              "tagName": "湖州市"
            },
            {
              "tagId": 330600,
              "tagName": "绍兴市"
            },
            {
              "tagId": 330700,
              "tagName": "金华市"
            },
            {
              "tagId": 330800,
              "tagName": "衢州市"
            },
            {
              "tagId": 330900,
              "tagName": "舟山市"
            },
            {
              "tagId": 331000,
              "tagName": "台州市"
            },
            {
              "tagId": 331100,
              "tagName": "丽水市"
            }
          ]
        },
        {
          "tagId": 340000,
          "tagName": "安徽省",
          "childBaseTag": [
            {
              "tagId": 340100,
              "tagName": "合肥市"
            },
            {
              "tagId": 340200,
              "tagName": "芜湖市"
            },
            {
              "tagId": 340300,
              "tagName": "蚌埠市"
            },
            {
              "tagId": 340400,
              "tagName": "淮南市"
            },
            {
              "tagId": 340500,
              "tagName": "马鞍山市"
            },
            {
              "tagId": 340600,
              "tagName": "淮北市"
            },
            {
              "tagId": 340700,
              "tagName": "铜陵市"
            },
            {
              "tagId": 340800,
              "tagName": "安庆市"
            },
            {
              "tagId": 341000,
              "tagName": "黄山市"
            },
            {
              "tagId": 341100,
              "tagName": "滁州市"
            },
            {
              "tagId": 341200,
              "tagName": "阜阳市"
            },
            {
              "tagId": 341300,
              "tagName": "宿州市"
            },
            {
              "tagId": 341500,
              "tagName": "六安市"
            },
            {
              "tagId": 341600,
              "tagName": "亳州市"
            },
            {
              "tagId": 341700,
              "tagName": "池州市"
            },
            {
              "tagId": 341800,
              "tagName": "宣城市"
            }
          ]
        },
        {
          "tagId": 350000,
          "tagName": "福建省",
          "childBaseTag": [
            {
              "tagId": 350100,
              "tagName": "福州市"
            },
            {
              "tagId": 350200,
              "tagName": "厦门市"
            },
            {
              "tagId": 350300,
              "tagName": "莆田市"
            },
            {
              "tagId": 350400,
              "tagName": "三明市"
            },
            {
              "tagId": 350500,
              "tagName": "泉州市"
            },
            {
              "tagId": 350600,
              "tagName": "漳州市"
            },
            {
              "tagId": 350700,
              "tagName": "南平市"
            },
            {
              "tagId": 350800,
              "tagName": "龙岩市"
            },
            {
              "tagId": 350900,
              "tagName": "宁德市"
            }
          ]
        },
        {
          "tagId": 360000,
          "tagName": "江西省",
          "childBaseTag": [
            {
              "tagId": 360100,
              "tagName": "南昌市"
            },
            {
              "tagId": 360200,
              "tagName": "景德镇市"
            },
            {
              "tagId": 360300,
              "tagName": "萍乡市"
            },
            {
              "tagId": 360400,
              "tagName": "九江市"
            },
            {
              "tagId": 360500,
              "tagName": "新余市"
            },
            {
              "tagId": 360600,
              "tagName": "鹰潭市"
            },
            {
              "tagId": 360700,
              "tagName": "赣州市"
            },
            {
              "tagId": 360800,
              "tagName": "吉安市"
            },
            {
              "tagId": 360900,
              "tagName": "宜春市"
            },
            {
              "tagId": 361000,
              "tagName": "抚州市"
            },
            {
              "tagId": 361100,
              "tagName": "上饶市"
            }
          ]
        },
        {
          "tagId": 370000,
          "tagName": "山东省",
          "childBaseTag": [
            {
              "tagId": 370100,
              "tagName": "济南市"
            },
            {
              "tagId": 370200,
              "tagName": "青岛市"
            },
            {
              "tagId": 370300,
              "tagName": "淄博市"
            },
            {
              "tagId": 370400,
              "tagName": "枣庄市"
            },
            {
              "tagId": 370500,
              "tagName": "东营市"
            },
            {
              "tagId": 370600,
              "tagName": "烟台市"
            },
            {
              "tagId": 370700,
              "tagName": "潍坊市"
            },
            {
              "tagId": 370800,
              "tagName": "济宁市"
            },
            {
              "tagId": 370900,
              "tagName": "泰安市"
            },
            {
              "tagId": 371000,
              "tagName": "威海市"
            },
            {
              "tagId": 371100,
              "tagName": "日照市"
            },
            {
              "tagId": 371300,
              "tagName": "临沂市"
            },
            {
              "tagId": 371400,
              "tagName": "德州市"
            },
            {
              "tagId": 371500,
              "tagName": "聊城市"
            },
            {
              "tagId": 371600,
              "tagName": "滨州市"
            },
            {
              "tagId": 371700,
              "tagName": "菏泽市"
            }
          ]
        },
        {
          "tagId": 410000,
          "tagName": "河南省",
          "childBaseTag": [
            {
              "tagId": 410100,
              "tagName": "郑州市"
            },
            {
              "tagId": 410200,
              "tagName": "开封市"
            },
            {
              "tagId": 410300,
              "tagName": "洛阳市"
            },
            {
              "tagId": 410400,
              "tagName": "平顶山市"
            },
            {
              "tagId": 410500,
              "tagName": "安阳市"
            },
            {
              "tagId": 410600,
              "tagName": "鹤壁市"
            },
            {
              "tagId": 410700,
              "tagName": "新乡市"
            },
            {
              "tagId": 410800,
              "tagName": "焦作市"
            },
            {
              "tagId": 410900,
              "tagName": "濮阳市"
            },
            {
              "tagId": 411000,
              "tagName": "许昌市"
            },
            {
              "tagId": 411100,
              "tagName": "漯河市"
            },
            {
              "tagId": 411200,
              "tagName": "三门峡市"
            },
            {
              "tagId": 411300,
              "tagName": "南阳市"
            },
            {
              "tagId": 411400,
              "tagName": "商丘市"
            },
            {
              "tagId": 411500,
              "tagName": "信阳市"
            },
            {
              "tagId": 411600,
              "tagName": "周口市"
            },
            {
              "tagId": 411700,
              "tagName": "驻马店市"
            },
            {
              "tagId": 419098,
              "tagName": "济源市",
            }
          ]
        },
        {
          "tagId": 420000,
          "tagName": "湖北省",
          "childBaseTag": [
            {
              "tagId": 420100,
              "tagName": "武汉市"
            },
            {
              "tagId": 420200,
              "tagName": "黄石市"
            },
            {
              "tagId": 420300,
              "tagName": "十堰市"
            },
            {
              "tagId": 420500,
              "tagName": "宜昌市"
            },
            {
              "tagId": 420600,
              "tagName": "襄阳市"
            },
            {
              "tagId": 420700,
              "tagName": "鄂州市"
            },
            {
              "tagId": 420800,
              "tagName": "荆门市"
            },
            {
              "tagId": 420900,
              "tagName": "孝感市"
            },
            {
              "tagId": 421000,
              "tagName": "荆州市"
            },
            {
              "tagId": 421100,
              "tagName": "黄冈市"
            },
            {
              "tagId": 421200,
              "tagName": "咸宁市"
            },
            {
              "tagId": 421300,
              "tagName": "随州市"
            },
            {
              "tagId": 422800,
              "tagName": "恩施土家族苗族自治州"
            },
            {
              "tagId": 429078,
              "tagName": "神农架林区"
            },
            {
              "tagId": 429093,
              "tagName": "天门市",
            },
            {
              "tagId": 429094,
              "tagName": "潜江市",
            },
            {
              "tagId": 429095,
              "tagName": "仙桃市",
            }
          ]
        },
        {
          "tagId": 430000,
          "tagName": "湖南省",
          "childBaseTag": [
            {
              "tagId": 430100,
              "tagName": "长沙市"
            },
            {
              "tagId": 430200,
              "tagName": "株洲市"
            },
            {
              "tagId": 430300,
              "tagName": "湘潭市"
            },
            {
              "tagId": 430400,
              "tagName": "衡阳市"
            },
            {
              "tagId": 430500,
              "tagName": "邵阳市"
            },
            {
              "tagId": 430600,
              "tagName": "岳阳市"
            },
            {
              "tagId": 430700,
              "tagName": "常德市"
            },
            {
              "tagId": 430800,
              "tagName": "张家界市"
            },
            {
              "tagId": 430900,
              "tagName": "益阳市"
            },
            {
              "tagId": 431000,
              "tagName": "郴州市"
            },
            {
              "tagId": 431100,
              "tagName": "永州市"
            },
            {
              "tagId": 431200,
              "tagName": "怀化市"
            },
            {
              "tagId": 431300,
              "tagName": "娄底市"
            },
            {
              "tagId": 433100,
              "tagName": "湘西土家族苗族自治州"
            }
          ]
        },
        {
          "tagId": 440000,
          "tagName": "广东省",
          "childBaseTag": [
            {
              "tagId": 440100,
              "tagName": "广州市"
            },
            {
              "tagId": 440200,
              "tagName": "韶关市"
            },
            {
              "tagId": 440300,
              "tagName": "深圳市"
            },
            {
              "tagId": 440400,
              "tagName": "珠海市"
            },
            {
              "tagId": 440500,
              "tagName": "汕头市"
            },
            {
              "tagId": 440600,
              "tagName": "佛山市"
            },
            {
              "tagId": 440700,
              "tagName": "江门市"
            },
            {
              "tagId": 440800,
              "tagName": "湛江市"
            },
            {
              "tagId": 440900,
              "tagName": "茂名市"
            },
            {
              "tagId": 441200,
              "tagName": "肇庆市"
            },
            {
              "tagId": 441300,
              "tagName": "惠州市"
            },
            {
              "tagId": 441400,
              "tagName": "梅州市"
            },
            {
              "tagId": 441500,
              "tagName": "汕尾市"
            },
            {
              "tagId": 441600,
              "tagName": "河源市"
            },
            {
              "tagId": 441700,
              "tagName": "阳江市"
            },
            {
              "tagId": 441800,
              "tagName": "清远市"
            },
            {
              "tagId": 441999,
              "tagName": "东莞市"
            },
            {
              "tagId": 442099,
              "tagName": "中山市"
            },
            {
              "tagId": 445100,
              "tagName": "潮州市"
            },
            {
              "tagId": 445200,
              "tagName": "揭阳市"
            },
            {
              "tagId": 445300,
              "tagName": "云浮市"
            }
          ]
        },
        {
          "tagId": 450000,
          "tagName": "广西壮族自治区",
          "childBaseTag": [
            {
              "tagId": 450100,
              "tagName": "南宁市"
            },
            {
              "tagId": 450200,
              "tagName": "柳州市"
            },
            {
              "tagId": 450300,
              "tagName": "桂林市"
            },
            {
              "tagId": 450400,
              "tagName": "梧州市"
            },
            {
              "tagId": 450500,
              "tagName": "北海市"
            },
            {
              "tagId": 450600,
              "tagName": "防城港市"
            },
            {
              "tagId": 450700,
              "tagName": "钦州市"
            },
            {
              "tagId": 450800,
              "tagName": "贵港市"
            },
            {
              "tagId": 450900,
              "tagName": "玉林市"
            },
            {
              "tagId": 451000,
              "tagName": "百色市"
            },
            {
              "tagId": 451100,
              "tagName": "贺州市"
            },
            {
              "tagId": 451200,
              "tagName": "河池市"
            },
            {
              "tagId": 451300,
              "tagName": "来宾市"
            },
            {
              "tagId": 451400,
              "tagName": "崇左市"
            }
          ]
        },
        {
          "tagId": 460000,
          "tagName": "海南省",
          "childBaseTag": [
            {
              "tagId": 460100,
              "tagName": "海口市"
            },
            {
              "tagId": 460200,
              "tagName": "三亚市"
            },
            {
              "tagId": 460300,
              "tagName": "三沙市"
            },
            {
              "tagId": 460400,
              "tagName": "儋州市"
            },
            {
              "tagId": 469071,
              "tagName": "五指山市"
            },
            {
              "tagId": 469072,
              "tagName": "琼海市"
            },
            {
              "tagId": 469073,
              "tagName": "文昌市"
            },
            {
              "tagId": 469074,
              "tagName": "万宁市"
            },
            {
              "tagId": 469075,
              "tagName": "东方市"
            },
            {
              "tagId": 469076,
              "tagName": "定安县"
            },
            {
              "tagId": 469077,
              "tagName": "屯昌县"
            },
            {
              "tagId": 469078,
              "tagName": "澄迈县"
            },
            {
              "tagId": 469079,
              "tagName": "临高县"
            },
            {
              "tagId": 469080,
              "tagName": "白沙黎族自治县"
            },
            {
              "tagId": 469081,
              "tagName": "昌江黎族自治县"
            },
            {
              "tagId": 469082,
              "tagName": "乐东黎族自治县"
            },
            {
              "tagId": 469083,
              "tagName": "陵水黎族自治县"
            },
            {
              "tagId": 469084,
              "tagName": "保亭黎族苗族自治县"
            },
            {
              "tagId": 469085,
              "tagName": "琼中黎族苗族自治县"
            }
          ]
        },
        {
          "tagId": 500000,
          "tagName": "重庆",
          "childBaseTag": null
        },
        {
          "tagId": 510000,
          "tagName": "四川省",
          "childBaseTag": [
            {
              "tagId": 510100,
              "tagName": "成都市"
            },
            {
              "tagId": 510300,
              "tagName": "自贡市"
            },
            {
              "tagId": 510400,
              "tagName": "攀枝花市"
            },
            {
              "tagId": 510500,
              "tagName": "泸州市"
            },
            {
              "tagId": 510600,
              "tagName": "德阳市"
            },
            {
              "tagId": 510700,
              "tagName": "绵阳市"
            },
            {
              "tagId": 510800,
              "tagName": "广元市"
            },
            {
              "tagId": 510900,
              "tagName": "遂宁市"
            },
            {
              "tagId": 511000,
              "tagName": "内江市"
            },
            {
              "tagId": 511100,
              "tagName": "乐山市"
            },
            {
              "tagId": 511300,
              "tagName": "南充市"
            },
            {
              "tagId": 511400,
              "tagName": "眉山市"
            },
            {
              "tagId": 511500,
              "tagName": "宜宾市"
            },
            {
              "tagId": 511600,
              "tagName": "广安市"
            },
            {
              "tagId": 511700,
              "tagName": "达州市"
            },
            {
              "tagId": 511800,
              "tagName": "雅安市"
            },
            {
              "tagId": 511900,
              "tagName": "巴中市"
            },
            {
              "tagId": 512000,
              "tagName": "资阳市"
            },
            {
              "tagId": 513200,
              "tagName": "阿坝藏族羌族自治州"
            },
            {
              "tagId": 513300,
              "tagName": "甘孜藏族自治州"
            },
            {
              "tagId": 513400,
              "tagName": "凉山彝族自治州"
            }
          ]
        },
        {
          "tagId": 520000,
          "tagName": "贵州省",
          "childBaseTag": [
            {
              "tagId": 520100,
              "tagName": "贵阳市"
            },
            {
              "tagId": 520200,
              "tagName": "六盘水市"
            },
            {
              "tagId": 520300,
              "tagName": "遵义市"
            },
            {
              "tagId": 520400,
              "tagName": "安顺市"
            },
            {
              "tagId": 520500,
              "tagName": "毕节市"
            },
            {
              "tagId": 520600,
              "tagName": "铜仁市"
            },
            {
              "tagId": 522300,
              "tagName": "黔西南布依族苗族自治州"
            },
            {
              "tagId": 522600,
              "tagName": "黔东南苗族侗族自治州"
            },
            {
              "tagId": 522700,
              "tagName": "黔南布依族苗族自治州"
            }
          ]
        },
        {
          "tagId": 530000,
          "tagName": "云南省",
          "childBaseTag": [
            {
              "tagId": 530100,
              "tagName": "昆明市"
            },
            {
              "tagId": 530300,
              "tagName": "曲靖市"
            },
            {
              "tagId": 530400,
              "tagName": "玉溪市"
            },
            {
              "tagId": 530500,
              "tagName": "保山市"
            },
            {
              "tagId": 530600,
              "tagName": "昭通市"
            },
            {
              "tagId": 530700,
              "tagName": "丽江市"
            },
            {
              "tagId": 530800,
              "tagName": "普洱市"
            },
            {
              "tagId": 530900,
              "tagName": "临沧市"
            },
            {
              "tagId": 532300,
              "tagName": "楚雄彝族自治州"
            },
            {
              "tagId": 532500,
              "tagName": "红河哈尼族彝族自治州"
            },
            {
              "tagId": 532600,
              "tagName": "文山壮族苗族自治州"
            },
            {
              "tagId": 532800,
              "tagName": "西双版纳傣族自治州"
            },
            {
              "tagId": 532900,
              "tagName": "大理白族自治州"
            },
            {
              "tagId": 533100,
              "tagName": "德宏傣族景颇族自治州"
            },
            {
              "tagId": 533300,
              "tagName": "怒江傈僳族自治州"
            },
            {
              "tagId": 533400,
              "tagName": "迪庆藏族自治州"
            }
          ]
        },
        {
          "tagId": 540000,
          "tagName": "西藏自治区",
          "childBaseTag": [
            {
              "tagId": 540100,
              "tagName": "拉萨市"
            },
            {
              "tagId": 540200,
              "tagName": "日喀则市"
            },
            {
              "tagId": 540300,
              "tagName": "昌都市"
            },
            {
              "tagId": 540400,
              "tagName": "林芝市"
            },
            {
              "tagId": 540500,
              "tagName": "山南市"
            },
            {
              "tagId": 540600,
              "tagName": "那曲市"
            },
            {
              "tagId": 542500,
              "tagName": "阿里地区"
            }
          ]
        },
        {
          "tagId": 610000,
          "tagName": "陕西省",
          "childBaseTag": [
            {
              "tagId": 610100,
              "tagName": "西安市"
            },
            {
              "tagId": 610200,
              "tagName": "铜川市"
            },
            {
              "tagId": 610300,
              "tagName": "宝鸡市"
            },
            {
              "tagId": 610400,
              "tagName": "咸阳市"
            },
            {
              "tagId": 610500,
              "tagName": "渭南市"
            },
            {
              "tagId": 610600,
              "tagName": "延安市"
            },
            {
              "tagId": 610700,
              "tagName": "汉中市"
            },
            {
              "tagId": 610800,
              "tagName": "榆林市"
            },
            {
              "tagId": 610900,
              "tagName": "安康市"
            },
            {
              "tagId": 611000,
              "tagName": "商洛市"
            }
          ]
        },
        {
          "tagId": 620000,
          "tagName": "甘肃省",
          "childBaseTag": [
            {
              "tagId": 620100,
              "tagName": "兰州市"
            },
            {
              "tagId": 620200,
              "tagName": "嘉峪关市"
            },
            {
              "tagId": 620300,
              "tagName": "金昌市"
            },
            {
              "tagId": 620400,
              "tagName": "白银市"
            },
            {
              "tagId": 620500,
              "tagName": "天水市"
            },
            {
              "tagId": 620600,
              "tagName": "武威市"
            },
            {
              "tagId": 620700,
              "tagName": "张掖市"
            },
            {
              "tagId": 620800,
              "tagName": "平凉市"
            },
            {
              "tagId": 620900,
              "tagName": "酒泉市"
            },
            {
              "tagId": 621000,
              "tagName": "庆阳市"
            },
            {
              "tagId": 621100,
              "tagName": "定西市"
            },
            {
              "tagId": 621200,
              "tagName": "陇南市"
            },
            {
              "tagId": 622900,
              "tagName": "临夏回族自治州"
            },
            {
              "tagId": 623000,
              "tagName": "甘南藏族自治州"
            }
          ]
        },
        {
          "tagId": 630000,
          "tagName": "青海省",
          "childBaseTag": [
            {
              "tagId": 630100,
              "tagName": "西宁市"
            },
            {
              "tagId": 630200,
              "tagName": "海东市"
            },
            {
              "tagId": 632200,
              "tagName": "海北藏族自治州"
            },
            {
              "tagId": 632300,
              "tagName": "黄南藏族自治州"
            },
            {
              "tagId": 632500,
              "tagName": "海南藏族自治州"
            },
            {
              "tagId": 632600,
              "tagName": "果洛藏族自治州"
            },
            {
              "tagId": 632700,
              "tagName": "玉树藏族自治州"
            },
            {
              "tagId": 632800,
              "tagName": "海西蒙古族藏族自治州"
            }
          ]
        },
        {
          "tagId": 640000,
          "tagName": "宁夏回族自治区",
          "childBaseTag": [
            {
              "tagId": 640100,
              "tagName": "银川市"
            },
            {
              "tagId": 640200,
              "tagName": "石嘴山市"
            },
            {
              "tagId": 640300,
              "tagName": "吴忠市"
            },
            {
              "tagId": 640400,
              "tagName": "固原市"
            },
            {
              "tagId": 640500,
              "tagName": "中卫市"
            }
          ]
        },
        {
          "tagId": 650000,
          "tagName": "新疆维吾尔自治区",
          "childBaseTag": [
            {
              "tagId": 650100,
              "tagName": "乌鲁木齐市"
            },
            {
              "tagId": 650200,
              "tagName": "克拉玛依市"
            },
            {
              "tagId": 650400,
              "tagName": "吐鲁番市"
            },
            {
              "tagId": 650500,
              "tagName": "哈密市"
            },
            {
              "tagId": 652300,
              "tagName": "昌吉回族自治州"
            },
            {
              "tagId": 652700,
              "tagName": "博尔塔拉蒙古自治州"
            },
            {
              "tagId": 652800,
              "tagName": "巴音郭楞蒙古自治州"
            },
            {
              "tagId": 652900,
              "tagName": "阿克苏地区"
            },
            {
              "tagId": 653000,
              "tagName": "克孜勒苏柯尔克孜自治州"
            },
            {
              "tagId": 653100,
              "tagName": "喀什地区"
            },
            {
              "tagId": 653200,
              "tagName": "和田地区"
            },
            {
              "tagId": 654000,
              "tagName": "伊犁哈萨克自治州"
            },
            {
              "tagId": 654200,
              "tagName": "塔城地区"
            },
            {
              "tagId": 654300,
              "tagName": "阿勒泰地区"
            },
            {
              "tagId": 659098,
              "tagName": "石河子市"
            },
            {
              "tagId": 659099,
              "tagName": "五家渠市"
            },
            {
              "tagId": 659100,
              "tagName": "北屯市"
            },
            {
              "tagId": 659101,
              "tagName": "铁门关市"
            },
            {
              "tagId": 659102,
              "tagName": "双河市"
            },
            {
              "tagId": 659103,
              "tagName": "可克达拉市"
            },
            {
              "tagId": 659104,
              "tagName": "昆玉市"
            },
            {
              "tagId": 659105,
              "tagName": "胡杨河市"
            },
            {
              "tagId": 659106,
              "tagName": "阿拉尔市"
            },
            {
              "tagId": 659107,
              "tagName": "图木舒克市"
            }
          ]
        },
        {
          "tagId": 710199,
          "tagName": "台湾省",
          "childBaseTag": null
        },
        {
          "tagId": 810000,
          "tagName": "香港特别行政区",
          "childBaseTag": null
        },
        {
          "tagId": 820000,
          "tagName": "澳门特别行政区",
          "childBaseTag": null
        }
      ],
      searchResults: [], // 搜索结果
      stayType: 1, // 默认为常驻
    };
  },
  computed: {
    totalSelectedCount() {
      let count = this.selectedCities.length;
      const directCities = this.provincesWithCities.filter(p => !p.childBaseTag);
      directCities.forEach(province => {
        if (this.selectedProvinces.includes(province.tagId)) {
          count++;
        }
      });
      return count;
    },
    isAllSelected() {
      // 检查是否所有省份都被选中
      const allProvincesSelected = this.provincesWithCities.every(province => {
        if (!province.childBaseTag) {
          // 直辖市直接检查是否被选中
          return this.selectedProvinces.includes(province.tagId);
        } else {
          // 省份检查是否所有城市都被选中
          return province.childBaseTag.every(city =>
            this.selectedCities.includes(city.tagId)
          );
        }
      });
      return allProvincesSelected;
    },
    formattedSelectedItems() {
      const result = [];
      const selectedCityIds = new Set(this.selectedCities);
      // 1. 处理直辖市（没有 childBaseTag）
      const directCities = this.provincesWithCities.filter(p => !p.childBaseTag);
      directCities.forEach(province => {
        if (this.selectedProvinces.includes(province.tagId)) {
          result.push({
            id: `direct-${province.tagId}`,
            label: province.tagName,
            type: 'direct'
          });
        }
      });
      // 2. 处理省份及其城市
      const provinces = this.provincesWithCities.filter(p => p.childBaseTag);
      provinces.forEach(province => {
        const cityList = province.childBaseTag;
        const selectedCitiesInProvince = cityList.filter(city => selectedCityIds.has(city.tagId));
        if (selectedCitiesInProvince.length === cityList.length) {
          // 全选该省所有城市
          result.push({
            id: `province-${province.tagId}`,
            label: `${province.tagName} (含${cityList.length}城市)`,
            type: 'province-all'
          });
        } else if (selectedCitiesInProvince.length > 0) {
          // 部分选择，只显示具体城市
          selectedCitiesInProvince.forEach(city => {
            result.push({
              id: `city-${city.tagId}`,
              label: city.tagName,
              type: 'city'
            });
          });
        }
      });
      return result;
    },
  },
  mounted() {
    // 组件挂载后初始化indeterminate状态
    this.$nextTick(() => {
      this.updateIndeterminateStates();
    });
  },
  watch: {
    // 添加监听selectedCities变化来更新复选框的indeterminate状态
    selectedCities: {
      handler() {
        this.$nextTick(() => {
          this.updateIndeterminateStates();
        });
      },
      deep: true
    },
    selectedProvinces: {
      handler() {
        this.$nextTick(() => {
          this.updateIndeterminateStates();
        });
      },
      deep: true
    }
  },
  methods: {
    // 添加关闭前的处理函数
    handleClose(done) {
      this.cancelSelection();
      done();
    },
    // 添加取消选择的方法
    cancelSelection() {
      this.dialogVisible = false;
      this.isSet = false;
    },
    // 更新复选框的indeterminate状态
    updateIndeterminateStates() {
      this.provincesWithCities.forEach(province => {
        if (province.childBaseTag && province.childBaseTag.length > 0) {
          const checkbox = document.getElementById('checkbox-' + province.tagId);
          if (checkbox) {
            checkbox.indeterminate = this.isProvincePartiallySelected(province);
          }
        }
      });
    },
    // 添加确认选择的方法
    confirmSelection() {
      let provinceIds = [];
      let cityIds = [];
      // 如果选择了"不限"或没有选择任何区域
      if (!this.isSet) {
        // 不传任何参数，表示不限
        this.$emit('confirm', null, null);
      } else {
        // 处理直辖市（没有 childBaseTag）
        const directCities = this.provincesWithCities
          .filter(p => !p.childBaseTag) // 直辖市
          .filter(p => this.selectedProvinces.includes(p.tagId))
          .map(p => p.tagId);
        provinceIds = [...directCities];
        // 处理省份和城市
        const provinces = this.provincesWithCities.filter(p => p.childBaseTag);
        provinces.forEach(province => {
          const cityList = province.childBaseTag;
          const selectedCitiesInProvince = cityList.filter(city =>
            this.selectedCities.includes(city.tagId)
          );
          // 如果该省份下的城市全被选中，则传递省份ID
          if (selectedCitiesInProvince.length === cityList.length) {
            provinceIds.push(province.tagId);
          }
          // 如果该省份下的城市部分被选中，则传递这些城市ID
          else if (selectedCitiesInProvince.length > 0) {
            cityIds = cityIds.concat(selectedCitiesInProvince.map(city => city.tagId));
          }
        });
        this.$emit('confirm', provinceIds, cityIds, this.stayType);
      }
      // 关闭对话框
      this.dialogVisible = false;
    },
    removeItem(item) {
      if (item.type === 'direct') {
        // 移除直辖市
        this.selectedProvinces = this.selectedProvinces.filter(id => id !== parseInt(item.id.split('-')[1]));
      } else if (item.type === 'province-all') {
        // 移除整个省份（即取消该省所有城市）
        const provinceId = parseInt(item.id.split('-')[1]);
        const province = this.provincesWithCities.find(p => p.tagId === provinceId);
        if (province && province.childBaseTag) {
          this.selectedCities = this.selectedCities.filter(id =>
            !province.childBaseTag.some(city => city.tagId === id)
          );
        }
      } else if (item.type === 'city') {
        // 移除单个城市
        const cityId = parseInt(item.id.split('-')[1]);
        this.selectedCities = this.selectedCities.filter(id => id !== cityId);
      }
    },
    clearSelected() {
      this.selectedCities = [];
      this.selectedProvinces = [];
    },
    // 搜索处理函数
    handleSearch() {
      if (!this.searchKey.trim()) {
        this.searchResults = [];
        return;
      }
      const results = [];
      // 遍历所有省份和城市进行模糊匹配
      for (const province of this.provincesWithCities) {
        // 匹配省份名称
        if (province.tagName.includes(this.searchKey)) {
          results.push({
            tagId: province.tagId,
            tagName: province.tagName,
            isProvince: true
          });
        }
        // 匹配城市名称
        if (province.childBaseTag) {
          for (const city of province.childBaseTag) {
            if (city.tagName.includes(this.searchKey)) {
              results.push({
                tagId: city.tagId,
                tagName: city.tagName,
                isProvince: false,
                provinceId: province.tagId
              });
            }
          }
        }
      }
      this.searchResults = results.slice(0, 10); // 限制最多显示10个结果
    },
    // 选择搜索结果
    selectSearchResult(item) {
      if (item.isProvince) {
        // 如果是省份，找到对应的省份对象
        const province = this.provincesWithCities.find(p => p.tagId === item.tagId);
        if (province) {
          // 选中该省份（如果是直辖市则直接选中，如果是普通省份则选中所有城市）
          this.toggleProvince(province);
          // 确保展开该省份
          if (!this.expandedProvinces.includes(province.tagId)) {
            this.expandedProvinces.push(province.tagId);
            this.lastExpandedProvince = province.tagId;
          }
        }
      } else {
        // 如果是城市，选中该城市
        const city = {tagId: item.tagId};
        this.toggleCity(city);
        // 同时展开该城市所属的省份
        this.showCities({tagId: item.provinceId});
      }
      // 清空搜索结果
      this.searchKey = '';
      this.searchResults = [];
    },
    // 判断省份是否被选中
    isProvinceSelected(province) {
      // 如果省份没有子城市，直接检查是否被选中
      if (!province.childBaseTag) {
        return this.selectedProvinces.includes(province.tagId);
      }
      // 如果省份有子城市，检查是否所有城市都被选中
      if (province.childBaseTag.length === 0) {
        return this.selectedProvinces.includes(province.tagId);
      }
      // 检查所有子城市是否都被选中
      const allSelected = province.childBaseTag.every(city =>
        this.selectedCities.includes(city.tagId)
      );
      return allSelected;
    },
    // 新增方法：检查省份是否部分选中
    isProvincePartiallySelected(province) {
      // 如果没有子城市，返回false
      if (!province.childBaseTag || province.childBaseTag.length === 0) {
        return false;
      }
      // 检查是否有任何城市被选中，但不是全部
      const selectedCount = province.childBaseTag.filter(city =>
        this.selectedCities.includes(city.tagId)
      ).length;
      return selectedCount > 0 && selectedCount < province.childBaseTag.length;
    },
    toggleProvince(province) {
      // 如果是直辖市（没有 childBaseTag），直接切换 selectedProvinces
      if (!province.childBaseTag) {
        const index = this.selectedProvinces.indexOf(province.tagId);
        if (index > -1) {
          this.selectedProvinces.splice(index, 1);
        } else {
          this.selectedProvinces.push(province.tagId);
        }
        return; // 结束函数
      }
      // 原来的逻辑：处理有子城市的省份
      const allSelected = province.childBaseTag.every(city => this.selectedCities.includes(city.tagId));
      if (allSelected) {
        this.selectedCities = this.selectedCities.filter(cityId =>
          !province.childBaseTag.some(city => city.tagId === cityId)
        );
      } else {
        province.childBaseTag.forEach(city => {
          if (!this.selectedCities.includes(city.tagId)) {
            this.selectedCities.push(city.tagId);
          }
        });
      }
      this.showCities(province);
    },
    showCities(province) {
      // 点击省份名称，展示子城市列表
      // 隐藏上一个展开的省份
      if (this.lastExpandedProvince && this.lastExpandedProvince !== province.tagId) {
        const lastIndex = this.expandedProvinces.indexOf(this.lastExpandedProvince);
        if (lastIndex > -1) {
          this.expandedProvinces.splice(lastIndex, 1);
        }
      }
      const index = this.expandedProvinces.indexOf(province.tagId);
      if (index > -1) {
        this.expandedProvinces.splice(index, 1);
        this.lastExpandedProvince = null;
      } else {
        this.expandedProvinces.push(province.tagId);
        this.lastExpandedProvince = province.tagId;
      }
    },
    toggleCity(city) {
      // 切换城市选中状态
      const index = this.selectedCities.indexOf(city.tagId);
      if (index > -1) {
        this.selectedCities.splice(index, 1);
      } else {
        this.selectedCities.push(city.tagId);
      }
    },
    selectAllProvinces() {
      // 全选或取消全选所有省份和直辖市
      const isCurrentlyAllSelected = this.isAllSelected;

      if (isCurrentlyAllSelected) {
        // 如果当前是全选状态，则取消全选
        this.selectedCities = [];
        this.selectedProvinces = [];
      } else {
        // 如果当前不是全选状态，则执行全选
        this.selectedCities = [];
        this.selectedProvinces = [];
        this.provincesWithCities.forEach(province => {
          if (province.childBaseTag) {
            // 有子城市的省份，选中所有子城市
            province.childBaseTag.forEach(city => {
              if (!this.selectedCities.includes(city.tagId)) {
                this.selectedCities.push(city.tagId);
              }
            });
          } else {
            // 直辖市没有子城市，直接选中省份本身
            if (!this.selectedProvinces.includes(province.tagId)) {
              this.selectedProvinces.push(province.tagId);
            }
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.area-container {
  display: flex;
  flex-direction: row;
}

.select-area {
  flex: 1;
  margin-right: 10px;
}

.selected-area {
  flex: 1;
}

.province-header {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e9e9e9;
  cursor: pointer;
}

.province-name {
  margin-left: 5px;
  font-weight: 500;
  color: #333;
}

.expand-icon {
  margin-left: auto;
  color: #666;
  font-size: 14px;
}

.city-list {
  margin-left: 20px;
  margin-top: 5px;
}

.city-item {
  margin: 5px 0;
}

.city-item input[type="checkbox"] {
  margin-right: 5px;
}

.city-item label {
  cursor: pointer;
}

.operation-btns {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

.btn {
  padding: 8px 16px;
  border: 1px solid #dcdfe6;
  background-color: white;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-unlimited {
  color: #666;
  border: none;
}

.btn-unlimited.active {
  background-color: #f5f7fa;
  color: #409eff;
  border: 1px solid #409eff;
}

.btn-set {
  color: #666;
  border: none;
}

.btn-set.active {
  background-color: #f5f7fa;
  color: #409eff;
  border: 1px solid #409eff;
}

.search-box {
  margin: 20px 0;
  position: relative;
}

.search-container {
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.search-input {
  flex: 1;
  padding: 8px 12px;
  border: none;
  outline: none;
  font-size: 14px;
  color: #606266;
  background-color: transparent;
}

.icon-search {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  color: #999;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #dcdfe6;
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.search-result-item {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
}

.search-result-item:hover {
  background-color: #f5f7fa;
}

.search-result-item:last-child {
  border-bottom: none;
}

.stay-type-switch {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.btn-stay,
.btn-current {
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  background-color: white;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-stay.active,
.btn-current.active {
  background-color: #f5f7fa;
  color: #409eff;
  border: 1px solid #409eff;
}

</style>




// WEBPACK FOOTER //
// src/components/vivo/Region.vue